// @ts-ignore
import {
  Grid2,
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Grid,
  Stack,
} from '@mui/material'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { Link as MuiLink } from '@mui/material'
import React, { useEffect, useState } from 'react'
import './Footer.css'

import myImage from '../../assets/images/cards.png'
// import Lights from '../../assets/images/emailBox.png'
import Logo from '../../assets/images/Logo.png'

const Footer: React.FC = () => {
  type GroupTextItem = {
    id: number
    Name: string
    Link: string
    bgcolor: string
    Icon: {
      url: string
    }[]
  }

  type GroupText = {
    big_txt: string
    small_txt: string
  }

  const [welcome, setWelcome] = useState<GroupText>()
  const [privacyLink, setPrivacyLink] = useState<string>()
  const [privacyTxt, setPrivacyTxt] = useState<string>('')
  const [explore, setExplore] = useState<GroupTextItem[]>([])
  const [licences, setLicences] = useState<GroupTextItem[]>([])
  const [followUs, setFollowUs] = useState<GroupTextItem[]>([])
  const [contactUsIcos, setContactUsIcos] = useState<GroupTextItem[]>([])
  const [contactUs, setContactUs] = useState<GroupText>()
  const [legal, setLegal] = useState<GroupTextItem[]>([])
  const [awards, setAwards] = useState<GroupTextItem[]>([])
  const BASE_URL = 'https://app.dfopsa.online'
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/api/footer?populate[welcome][populate]=*&populate[Explore][populate]=Icon&populate[Legal][populate]=Icon&populate[Licences][populate]=Icon&populate[FollowUs][populate]=Icon&populate[ContactUs][populate]=*&populate[Legal][populate]=Icon&populate[Awards][populate]=Icon&populate[ContactUsIcos][populate]=Icon`
        )

        const welcome = res?.data?.data?.welcome || []
        setWelcome(welcome)

        const privacyLink = res?.data?.data?.PrivacyLink || []
        setPrivacyLink(privacyLink)

        const privacyTxt = res?.data?.data?.PrivacyTxt || []
        setPrivacyTxt(privacyTxt)

        const explore = res?.data?.data?.Explore || []
        setExplore(explore)

        const licence = res?.data?.data?.Licences || []
        setLicences(licence)

        const followUs = res?.data?.data?.FollowUs || []
        setFollowUs(followUs)

        const contactUsIcos = res?.data?.data?.ContactUsIcos || []
        setContactUsIcos(contactUsIcos)

        const contactUs = res?.data?.data?.ContactUs || []
        setContactUs(contactUs)

        const legal = res?.data?.data?.Legal || []
        setLegal(legal)

        const awards = res?.data?.data?.Awards || []
        setAwards(awards)
      } catch (error) {
        console.error('Failed to fetch statistic data:', error)
      }
    }

    fetchData()
  }, [])

  return (
    <>
      {/* <Grid2 id='email-container' container justifyContent="center" alignItems="center">
        <Grid2 className='inner-container1' container justifyContent="center" alignItems="center"
               columns={{xs: 10}}
               size={{xs:10}}
        >
            <Grid2 className='email-box'
                   size={{xs:10}}
                   spacing={{xs: 1, md: 2}}
                   container justifyContent="center" alignItems="center"
            >
                <Grid2 className='news-text-box' size={{xs: 10, md: 5}} justifyContent="center" alignItems="center">
                    <Typography className='text-h2'>Be the first to get the news</Typography>
                    <Typography className='text-h1'>The latest news and blog sent to your inbox weekly.</Typography>
                </Grid2>
                
                <Grid2 className='news-text-box' size={{xs: 10, md: 5}} justifyContent="center" alignItems="center">
                    <Box className='email-input'> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                            <path d="M12.2968 5.14331L12.3003 5.14039C12.7747 4.75502 12.8506 4.05204 12.4694 3.57466C12.086 3.07734 11.3725 3.01297 10.8998 3.39505L8.57322 5.25337L8.57219 5.2542C8.40633 5.38733 8.15536 5.47168 7.87634 5.47168C7.59732 5.47168 7.34636 5.38733 7.1805 5.2542L7.17946 5.25337L4.85291 3.39511C4.36391 2.99971 3.66656 3.10296 3.28932 3.56725L3.28268 3.57559C2.91135 4.05089 2.98368 4.75358 3.45975 5.14039L3.46339 5.14331L5.7894 7.00116C6.38628 7.48681 7.1474 7.71236 7.88006 7.71236C8.61594 7.71236 9.36783 7.48506 9.96926 7.00233C9.96907 7.00247 9.96945 7.00218 9.96926 7.00233L12.2968 5.14331ZM4.16111 0.735596H11.599C12.6292 0.735596 13.4024 0.993219 13.9156 1.4698C14.4215 1.93941 14.7601 2.7014 14.7601 3.89671V9.1033C14.7601 10.2985 14.4215 11.0605 13.9156 11.5301C13.4024 12.0068 12.6292 12.2644 11.599 12.2644H4.16111C3.13094 12.2644 2.35768 12.0068 1.84445 11.5301C1.33871 11.0605 1 10.2985 1 9.1033V3.89671C1 2.7014 1.33871 1.93941 1.84445 1.4698C2.35768 0.993219 3.13094 0.735596 4.16111 0.735596Z" fill="black"/>
                            <path d="M9.96926 7.00233C9.36783 7.48506 8.61594 7.71236 7.88006 7.71236C7.1474 7.71236 6.38628 7.48681 5.7894 7.00116L3.46339 5.14331L3.45975 5.14039C2.98368 4.75358 2.91135 4.05089 3.28268 3.57559L3.28932 3.56725C3.66656 3.10296 4.36391 2.99971 4.85291 3.39511L7.17946 5.25337L7.1805 5.2542C7.34636 5.38733 7.59732 5.47168 7.87634 5.47168C8.15536 5.47168 8.40633 5.38733 8.57219 5.2542L8.57322 5.25337L10.8998 3.39505C11.3725 3.01297 12.086 3.07734 12.4694 3.57466C12.8506 4.05204 12.7747 4.75502 12.3003 5.14039L12.2968 5.14331L9.96926 7.00233ZM9.96926 7.00233C9.96945 7.00218 9.96907 7.00247 9.96926 7.00233ZM4.16111 0.735596H11.599C12.6292 0.735596 13.4024 0.993219 13.9156 1.4698C14.4215 1.93941 14.7601 2.7014 14.7601 3.89671V9.1033C14.7601 10.2985 14.4215 11.0605 13.9156 11.5301C13.4024 12.0068 12.6292 12.2644 11.599 12.2644H4.16111C3.13094 12.2644 2.35768 12.0068 1.84445 11.5301C1.33871 11.0605 1 10.2985 1 9.1033V3.89671C1 2.7014 1.33871 1.93941 1.84445 1.4698C2.35768 0.993219 3.13094 0.735596 4.16111 0.735596Z" stroke="black" stroke-width="1.11569"/>
                        </svg>
                        <TextField
                        sx={{
                            '& .MuiInputBase-input':{
                                color:'#000 !important',

                            }
                        }}
                        placeholder='Your Email'></TextField>
                        <Button className='email-input-button'>Subscribe</Button>
                    </Box>
                </Grid2>

                <Box className='cards-img'>
                    <img className='cards_layout' src={myImage} alt="" />
                </Box>
            </Grid2>
            <Box className='lights-img'>
            </Box>
        </Grid2>



        <Grid2 className='inner-container2'>
            <img id="logo-img" src={Logo} alt="Company logo" />
            <Box>
                <Box className='rights_box'>
                    <Typography>© 8RABBITS 2025. All rights reserved.</Typography>
                </Box>
                <Box className='text_privacy'>
                    <Typography>Privacy policy</Typography>
                    <Typography>Cookies</Typography>
                </Box>
            </Box>
        </Grid2>
    </Grid2> */}
      <Box className='footherColors' sx={{ py: 6 }}>
        <Container maxWidth={false} disableGutters sx={{ px: 6 }}>
          <Grid container spacing={1}>
            {/* Explore */}
            <Grid item xs={6} sm={4} md={2}>
              {Array.isArray(explore) && explore.length > 0 && (
                <>
                  <Typography
                    textAlign={'center'}
                    variant='h6'
                    gutterBottom
                    fontWeight='bold'
                  >
                    Explore
                  </Typography>
                  <Stack textAlign={'center'} spacing={1}>
                    {explore.map(item => (
                      <MuiLink
                        component={Link}
                        to={`${item.Link}`}
                        underline='hover'
                        color={'#fff'}
                      >
                        {item.Name}
                      </MuiLink>
                    ))}
                  </Stack>
                </>
              )}
            </Grid>

            {/* Legal */}
            <Grid item xs={6} sm={6} md={2}>
              {Array.isArray(legal) && legal.length > 0 && (
                <>
                  <Typography
                    textAlign={'center'}
                    variant='h6'
                    gutterBottom
                    fontWeight='bold'
                  >
                    Legal
                  </Typography>
                  <Stack textAlign={'center'} spacing={1}>
                    {legal.map(item => (
                      <MuiLink
                        component={Link}
                        to={`${item.Link}`}
                        underline='hover'
                        color={'#fff'}
                      >
                        {item.Name}
                      </MuiLink>
                    ))}
                  </Stack>
                </>
              )}
            </Grid>

            {/* Logo & Info */}
            <Grid item xs={6} md={4} sx={{ mb: { sm: 0, md: -5 } }}>
              <Box sx={{ mb: 0 }} margin={'auto'} position='relative'>
                <img
                  className={'logoFooter'}
                  src='/static/media/Logo.76d81d616c4f525fa1a4.png'
                  alt='8Rabbits'
                  style={{ maxWidth: 130, filter: 'grayscale(100%)' }}
                />
              </Box>
              <Typography
                textAlign={'center'}
                variant='body1'
                sx={{ fontStyle: 'italic', color: '#f54655' }}
              >
                {welcome?.small_txt}
              </Typography>
              <Typography
                textAlign={'center'}
                variant='body2'
                sx={{ mt: 2, color: '#9fa2a4' }}
              >
                {welcome?.big_txt}
              </Typography>
              <Typography
                textAlign={'center'}
                variant='caption'
                display='block'
                sx={{ mt: { xs: 4, md: 8 }, color: '#9fa2a4' }}
              >
                {privacyTxt}
              </Typography>
            </Grid>

            {/* Social Media */}
            <Grid item xs={6} sm={4} md={2}>
              {Array.isArray(followUs) && followUs.length > 0 && (
                <>
                  <Typography
                    textAlign={'center'}
                    variant='h6'
                    gutterBottom
                    fontWeight='bold'
                  >
                    Follow us
                  </Typography>
                  <Stack
                    width={'fit-content'}
                    margin={'auto'}
                    spacing={1}
                    direction='row'
                    alignItems='center'
                  >
                    {followUs.map(
                      item =>
                        Array.isArray(item.Icon) &&
                        item.Icon.length > 0 && (
                          <MuiLink
                            key={item.id}
                            component={Link}
                            to={`${item.Link}`}
                            underline='hover'
                          >
                            <img
                              src={`${BASE_URL}${item.Icon?.[0]?.url}`}
                              alt={`${item.Name}`}
                              style={{ maxWidth: 40 }}
                            />
                          </MuiLink>
                        )
                    )}
                  </Stack>
                </>
              )}
            </Grid>

            {/* Contact */}
            <Grid item xs={12} sm={4} md={2}>
              {Array.isArray(legal) && legal.length > 0 && (
                <>
                  <Typography textAlign={'center'} variant='h6' gutterBottom>
                    Get in touch
                  </Typography>
                  <Stack
                    width={'fit-content'}
                    margin={'auto'}
                    spacing={1}
                    direction='row'
                    alignItems='center'
                  >
                    {contactUsIcos.map(
                      item =>
                        Array.isArray(item.Icon) &&
                        item.Icon.length > 0 &&
                        (item.Name !== 'Gmail' ? (
                          <MuiLink
                            key={item.id}
                            component={Link}
                            to={`${item.Link}`}
                            underline='hover'
                          >
                            <img
                              src={`${BASE_URL}${item.Icon?.[0]?.url}`}
                              alt={`${item.Name}`}
                              style={{ maxWidth: 40 }}
                            />
                          </MuiLink>
                        ) : (
                          <MuiLink
                            key={item.id}
                            component={Link}
                            to={`${item.Link}`}
                            underline='hover'
                          >
                            <img
                              src={`${BASE_URL}${item.Icon?.[0]?.url}`}
                              alt={`${item.Name}`}
                              style={{ maxWidth: 40 }}
                              onClick={() => setIsDialogOpen(true)}
                            />
                          </MuiLink>
                        ))
                    )}
                  </Stack>
                </>
              )}
            </Grid>
          </Grid>

          {/*/!* Awards *!/*/}
          {/*  <Box sx={{ mt: 0, textAlign: 'center' }}>*/}
          {/*    {Array.isArray(awards) && awards.length > 0 && (*/}
          {/*      <>*/}
          {/*        <Typography variant="h6" gutterBottom fontWeight="bold">Awards</Typography>*/}
          {/*          <Stack direction="row" justifyContent="center" spacing={4} flexWrap="wrap">*/}
          {/*            {awards.map((item) => {*/}
          {/*              const hasImage = Array.isArray(item?.Icon) && item?.Icon?.length > 0;*/}

          {/*              return (*/}
          {/*                <MuiLink*/}
          {/*                  key={item.id}*/}
          {/*                  component={Link}*/}
          {/*                  to={item.Link}*/}
          {/*                  underline="hover"*/}
          {/*                >*/}
          {/*                  <Box textAlign="center">*/}
          {/*                    {hasImage && (*/}
          {/*                      <img*/}
          {/*                        src={`${BASE_URL}${item.Icon[0].url}`}*/}
          {/*                        alt={item.Name}*/}
          {/*                        style={{ height: 50 }}*/}
          {/*                      />*/}
          {/*                    )}*/}
          {/*                    <Typography variant="caption" display="block" color='#fff' sx={{ mt: hasImage ? 0 : 2, fontWeight: hasImage ? 'none' : 'bold' }}>*/}
          {/*                      {item.Name}*/}
          {/*                    </Typography>*/}
          {/*                  </Box>*/}
          {/*                </MuiLink>*/}
          {/*              );*/}
          {/*            })}*/}
          {/*          </Stack>*/}
          {/*      </>*/}
          {/*    )}*/}
          {/*  </Box>*/}
        </Container>
      </Box>
    </>
  )
}

export default Footer
